import { Injectable } from '@angular/core';
import { ApiActions } from './util.service';
import { Subject } from 'rxjs';
import { Bookmarks } from 'src/app/model';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { MsgService } from './msg.service';
import { CommonDataService } from './common-data.service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class BookmarksService {

  public pageName = 'Bookmarks';
  public dataList = new Subject<Array<Bookmarks>>();

  constructor(
    private http: HttpClient,
    private config: AppConfigService,
    private common: CommonDataService,
		private msgSvc: MsgService,
		private router: Router
  ) { }

  private getUrl(apiOption: ApiActions) {
    return this.config.ipAddress + this.config.BookmarksApi[apiOption];
  }

  public getDataRecords() {

    this.http.post(this.getUrl(ApiActions.Get), null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          const dataArray: Array<Bookmarks> = [];
          response.result.Bookmarks.map(element => {
            element.status = element.rec_status + '' === '1' ? true : false;
            dataArray.push(element);
          });
          this.dataList.next(dataArray);
        }
      },
        err => {
            this.msgSvc.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
  }

  public addData(objData: Bookmarks) {
    const fData = new FormData();
    fData.append('Bookmark Id', objData.bookmark_id + '');
	fData.append('User Id', objData.user_id + '');
	fData.append('Prod Id', objData.prod_id + '');
  fData.append('Blog Id', objData.blog_id + '');
	fData.append('Post Id', objData.post_id + '');
  
    return this.common.executeAction(fData, this.getUrl(ApiActions.Create), this.pageName);
  }

  public updateData(objData: Bookmarks) {
    const fData = new FormData();
    fData.append('Bookmark Id', objData.bookmark_id + '');
    fData.append('user Id', objData.user_id + '');
    fData.append('Blog Id', objData.blog_id + '');
    fData.append('Prod Id', objData.prod_id + '');
    fData.append('Post Id', objData.post_id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.Update), this.pageName);
  }

  public deleteData(id: number) {
    const fData = new FormData();
    fData.append('BookmarksId', id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.Delete), this.pageName);
  }

  public updateStatus(objData: Bookmarks) {
    const fData = new FormData();
    fData.append('stat', objData.status ? '1' : '0');
    fData.append('BookmarkId', objData.bookmark_id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.UpdateStatus), this.pageName);
  }
}
